/**
 * @generated SignedSource<<4ff2aa6ea88e18502c0dfd9ce1a32b3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksPostiesArticleArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"genericPostiesArticleContent" | "helpersGetArticleTypeArticle">;
  readonly " $fragmentType": "hooksPostiesArticleArticle";
};
export type hooksPostiesArticleArticle$key = {
  readonly " $data"?: hooksPostiesArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksPostiesArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "customContents"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksPostiesArticleArticle",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "customContents",
          "variableName": "customContents"
        }
      ],
      "kind": "FragmentSpread",
      "name": "genericPostiesArticleContent"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersGetArticleTypeArticle",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleTypeSegment",
          "kind": "LinkedField",
          "name": "types",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ArticleType",
              "kind": "LinkedField",
              "name": "value",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entityId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "a45c5558a40629c6eff674cbad939e53";

export default node;
